import { About } from '../components';

const Presentation = () => {
   return <About showDetails />;
};
export default Presentation;
